module.exports = __webpack_public_path__ + "img/sbp-slider1.5d351ab4.png";